// Role identifiers used by the backend
export const ROLE = {
    OWNER: "owner",
    ADMIN_SALES: "admin_sales",
    ADMIN_INPUT: "admin_input",
    FINANCE: "finance",
    SUPERVISOR: "supervisor",
    META_ADS_VIEWER: "meta_ads_viewer",
    // Legacy aliases — backend still accepts them, but new users use the three above.
    ADMIN: "admin",
    RESELLER: "reseller",
    DISTRIBUTOR: "distributor",
};

export const EDITOR_ROLES = new Set([ROLE.OWNER, ROLE.ADMIN_INPUT, ROLE.ADMIN]);
export const CATALOG_ROLES = new Set([
    ROLE.OWNER,
    ROLE.ADMIN_INPUT,
    ROLE.ADMIN_SALES,
    ROLE.SUPERVISOR,
    ROLE.ADMIN,
    ROLE.RESELLER,
    ROLE.DISTRIBUTOR,
]);
export const PRODUCTS_PAGE_ROLES = new Set([ROLE.OWNER, ROLE.ADMIN_INPUT, ROLE.ADMIN_SALES, ROLE.SUPERVISOR, ROLE.ADMIN]);

export function canEdit(role) {
    return EDITOR_ROLES.has(role);
}

export function canDelete(role) {
    return role === ROLE.OWNER;
}

export function canManageUsers(role) {
    return role === ROLE.OWNER;
}

const LABELS = {
    [ROLE.OWNER]: "Owner",
    [ROLE.ADMIN_INPUT]: "Admin Input",
    [ROLE.ADMIN_SALES]: "Admin Sales",
    [ROLE.FINANCE]: "Finance",
    [ROLE.SUPERVISOR]: "Supervisor",
    [ROLE.META_ADS_VIEWER]: "Meta Ads Viewer",
    [ROLE.ADMIN]: "Admin",
    [ROLE.RESELLER]: "Reseller",
    [ROLE.DISTRIBUTOR]: "Distributor",
};

export function roleLabel(role) {
    return LABELS[role] || role;
}

// Roles exposed in the user creation / role-change dropdown.
export const ASSIGNABLE_ROLES = [
    { value: ROLE.ADMIN_SALES, label: "Admin Sales" },
    { value: ROLE.ADMIN_INPUT, label: "Admin Input" },
    { value: ROLE.FINANCE, label: "Finance" },
    { value: ROLE.SUPERVISOR, label: "Supervisor" },
    { value: ROLE.META_ADS_VIEWER, label: "Meta Ads Viewer" },
];

export const MULTI_BRAND_ROLES = [ROLE.ADMIN_SALES, ROLE.ADMIN_INPUT, ROLE.FINANCE, ROLE.SUPERVISOR, ROLE.ADMIN];
export const REPORTING_ROLES = [ROLE.OWNER, ROLE.FINANCE, ROLE.ADMIN_SALES, ROLE.SUPERVISOR];
export const SALES_SUBMIT_ROLES = [ROLE.OWNER, ROLE.ADMIN_SALES];
export const META_ADS_ROLES = [ROLE.OWNER, ROLE.SUPERVISOR, ROLE.META_ADS_VIEWER];

// Landing page after login / on redirects. Finance is reporting-only; Meta Ads Viewer sees only Meta Ads.
export function homeFor(role) {
    if (role === ROLE.META_ADS_VIEWER) return "/meta-ads";
    return role === ROLE.FINANCE ? "/reporting" : "/catalog";
}
